// import AlertSnackbar from "components/AlertSnackbar";
import Loading from 'components/Loading';
// import React, {useState, createContext} from "react";

// export const LoadingContext = createContext();


// function LoadingProvider(props) {
//     // the loadCount represents the number of active requests that didn't get any response yet
//   const [loadCount, setLoadCount] = useState(0)

//   return (
//     <LoadingContext.Provider
//       value={{
//         loadCount,
//         setLoadCount,
//       }}
//     >
//       <Loading loadCount={loadCount} />

//       {props.children}
//     </LoadingContext.Provider>
//   );

// }

// export default LoadingProvider;


import React from "react";

var LoadingStateContext = React.createContext();
var LoadingDispatchContext = React.createContext();

function layoutReducer(state, action) {
  switch (action.type) {
    case "SET_LOAD_COUNT":
      return { ...state, loadCount: action.payload };
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

// we created two different providers (one for global state and the other for dispatch (setting global state))
//  best practice => + Fail fast and catch the exception using useLoadingState() and useLoadingDispatch()
function LoadingProvider({ children }) {

var [state, dispatch] = React.useReducer(layoutReducer, {
    loadCount: 0,
  });
  return (
    <LoadingStateContext.Provider value={state}>
      <LoadingDispatchContext.Provider value={dispatch}>
      <Loading loadCount={state.loadCount} />
        {children}
      </LoadingDispatchContext.Provider>
    </LoadingStateContext.Provider>
  );
}

function useLoadingState() {
  var context = React.useContext(LoadingStateContext);
  if (context === undefined) {
    throw new Error("useLoadingState must be used within a LoadingProvider");
  }
  return context;
}

function useLoadingDispatch() {
  var context = React.useContext(LoadingDispatchContext);
  if (context === undefined) {
    throw new Error("useLoadingDispatch must be used within a LoadingProvider");
  }
  return context;
}

export { LoadingProvider, useLoadingState, useLoadingDispatch, setLoadCount};

function setLoadCount(dispatch, payload) {
  dispatch({
    type: "SET_LOAD_COUNT",
    payload
  });
}
